import DropDown from 'assets/iconTsx/DropDown'
import React, { useEffect, useRef } from 'react'
import Avatar from './avatar'


interface Props {
    liste:any
    isOpen?: boolean
    setIsOpen?:(e: boolean)=>void
    value:string
    setValue:(val:string)=>void
    placeholder?: string
    label:string
    isObligatoire?:boolean
    styleInput?:string
    icon?:string
    handleClick:(item:any)=>void
    avatar?: string
    messageIsEmpty?:string
    isDropDown?:boolean
    // isDesabled?:boolean
    styleLabel?:string
    

}

const InputSelectComponent: React.FC <Props> = ({
    label,isObligatoire=true,
    placeholder,
    liste, isOpen, setIsOpen,
    value, setValue,
    styleInput='h-[56px]',
    icon, 
    avatar,
    handleClick,
    messageIsEmpty,
    isDropDown=true,
    // isDesabled=false
    styleLabel
    }) => {

const dropDownRef= useRef<HTMLDivElement>(null)
const scrollAreaRef = useRef<HTMLDivElement>(null)
const scrollThumbRef = useRef<HTMLDivElement>(null)

        useEffect(()=>{
            const handleClickOutside= (event: MouseEvent)=>{
                
                if (dropDownRef.current && !dropDownRef.current.contains(event.target as Node)){
                    setIsOpen?.(false)
                }
            }
             document.addEventListener('mousedown', handleClickOutside)

  return () => {
    document.removeEventListener('mousedown', handleClickOutside)
  }
        },[])

    useEffect(() => {
          const content = scrollAreaRef.current
          const thumb = scrollThumbRef.current
        
          if (!content || !thumb) return
        
          const updateThumb = () => {
            const ratio = content.scrollTop / (content.scrollHeight - content.clientHeight)
            thumb.style.transform = `translateY(${ratio * 100}%)`
          }
        
          content.addEventListener('scroll', updateThumb)
          return () => content.removeEventListener('scroll', updateThumb)
        }, [isOpen])

  return (
    <div  className='font-semibold font-roboto relative'>
        <h3 className={`${styleLabel ? styleLabel : 'h3'} `}>
          {label} { (isObligatoire) && <span className="text-[#EE443F]">*</span>}
        </h3>
       
        <div ref={dropDownRef} className={ `${styleInput}  ${messageIsEmpty === 'cursor-not-allowed' && liste.length===0 ? 'cursor-not-allowed bg-[#F1F1FF]' : !isDropDown ? 'cursor-default' :  'cursor-pointer'} rounded-[16px] mt-3   w-full border  flex items-center justify-between px-4 
            ${!value ? 'text-[#D1D1FF] border-[#AEB6FB]': !isOpen ? ' border-[#AEB6FB] text-[#35258B]' : 'border-[#5754E5] text-[#5754E5]'} 
          
            `}
            // ${isDesabled && 'bg-[#F1F1FF] text-[#AEB6FB] font-medium'}
            
            onClick={()=>{{
                if(isDropDown)
               { if(messageIsEmpty === 'cursor-not-allowed' && liste.length===0 ) 
                {setIsOpen?.(false)}
               else{
                 setIsOpen?.(!isOpen)
                }}}
            }}
        >
            <div className='flex items-center gap-4'>
               
                {icon && 
                (avatar ? 
                    <Avatar avatar={icon} styleCss="w-[36px] h-[36px]" /> 
                    :  <img src={icon} alt=''/>)
                }
                 {value ? value : placeholder} 
            </div>
           {isDropDown && <DropDown styleCssImage={`${ isOpen ? 'fill-[#5754E5] rotate-180' : 'fill-[#AEB6FB]'} `} />}
        </div>
        {(isOpen && isDropDown) && 
        (liste.length !== 0 ?
        <div className="absolute py-2 z-10 w-full rounded-lg bg-white shadow-[0px_6px_10px_rgba(87,84,229,0.15)]">
          
            {/* CONTENU SCROLLABLE */}
            <div ref={scrollAreaRef}
                className=' overflow-y-scroll scrollbar-hide max-h-[150px]  w-full top-full cursor-pointer'>
                {liste.map((item:any, index:number)=>(
                <div key={index} 
                    onMouseDown={(e) => {
                        e.stopPropagation()   
                        handleClick(item)
                        setValue(item.value)
                        setIsOpen?.(false)
                    }}
                    className={`${item.value === value ? 'bg-[#F1F1FF] text-[#5754E5] ': 'text-[#35258B]'} h-[50px] flex justify-between items-center px-4 hover:text-[#4D36CC] `} >
                        <div className='flex  gap-4 items-center '>
                            {(icon || item.image) &&
                             (avatar ? 
                                <Avatar avatar={item.image} styleCss="w-[36px] h-[36px]" /> 
                                :  <img src={item.image} alt=''/>)
                            }
                            {item.value || item}
                        </div>
                        {item.bientot && <div className='text-white bg-[#EC1C24] rounded-[3px] w-[50px] py-3 text-center '>Bientôt</div> }
                        

                    </div>
                ))}
            </div>

             {/* SCROLLBAR OVERLAY */}
           { liste.length >2 && <div className="absolute top-4 bottom-4 right-2 w-[8px] bg-[#E2E2FB] rounded-full">
                <div ref={scrollThumbRef}
                className="w-full bg-[#AEB6FB] rounded-full"
                    style={{ height: '50%' }}
                  />
            </div>}
        </div>
        :
       
        <span className={` absolute  mt-1 py-4 z-10 px-4 w-full rounded-lg bg-white shadow-[0px_6px_10px_rgba(87,84,229,0.15)] text-[#D1D1FF] `}>{messageIsEmpty}</span>
        )
        }


    </div>
  )
}

export default InputSelectComponent
